// extracted by mini-css-extract-plugin
module.exports = {"header":"FidPointsSearch_header__zlsFt"};